module.exports = __webpack_public_path__ + "img/calendar_icon_new.6135095e.svg";